import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: 200px;
	height: 100%;
	border-radius: 5px;
	overflow: hidden;
	border: 1px solid rgba(255, 255, 255, 0.25);
	background: rgba(0, 0, 0, 0.25);
`;

const StyledSlides = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

const StyledImageWrapper = styled.div<{ $active: boolean }>`
	position: absolute;
	inset: 0;
	opacity: ${({ $active }) => ($active ? 1 : 0)};
	transform: scale(${({ $active }) => ($active ? 1 : 1.05)});
	transition:
		opacity 0.4s ease,
		transform 0.6s ease;
	will-change: opacity, transform;
`;

const StyledSlideImage = styled.div<{ $active: boolean }>`
	position: absolute;
	inset: 0;
	background-size: cover;
	background-position: center;
	opacity: ${({ $active }) => ($active ? 1 : 0)};
	transform: scale(${({ $active }) => ($active ? 1 : 1.05)});
	transition:
		opacity 0.4s ease,
		transform 0.6s ease;
	will-change: opacity, transform;
	user-select: none;
	pointer-events: none;
`;

const StyledSliderContainer = styled.div`
	position: absolute;
	left: 50%;
	bottom: 30px;
	transform: translateX(-50%);
	display: flex;
	gap: 8px;
	z-index: 2;
`;

const StyledSliderDot = styled.button<{ $active: boolean }>`
	position: relative;
	width: ${({ $active }) => ($active ? '40px' : '10px')};
	height: 10px;
	border-radius: 10px;
	border: none;
	padding: 0;
	background: ${({ $active }) =>
		$active ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0.25)'};
	cursor: pointer;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	transition:
		background 0.2s ease,
		width 0.2s ease;

	&:focus-visible {
		outline: 2px solid rgba(255, 255, 255, 0.7);
		outline-offset: 2px;
	}
`;

const StyledProgressIndicator = styled.div`
	position: absolute;
	inset: 0;
	background: rgba(255, 255, 255, 0.9);
	transform-origin: left center;
	transform: scaleX(0);
	transition: transform 0.1s linear;
	pointer-events: none;
`;

export {
	StyledContainer,
	StyledImageWrapper,
	StyledProgressIndicator,
	StyledSlideImage,
	StyledSliderContainer,
	StyledSliderDot,
	StyledSlides,
};
